import styled from 'styled-components';

export const Footer = styled.div`
  padding-top: 42px;
  padding-bottom:32px;
  box-sizing: border-box;
`;

export const Nav = styled.ul`
  display: flex;
  justify-content: center;
`;

export const NavItem = styled.li`
  position: relative;
  &:not(:first-child) {
    padding-left: 36px;
  }
  &:not(:last-child) {
    padding-right: 40px;
  }
`;

export const NavLink = styled.span`
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.5);
`;

export const CopyRight = styled.div`
  margin-top: 39px;
`;

export const CopyRightText = styled.span`
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.2);
  display:block;
  text-align:center;
`;
